import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { ApplicationState } from "../../redux/reducers";
import { IEvent } from "../../interfaces/IEvent";
import NumberField from "../controls/NumberField";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from "../controls/SubmitButton";
import { ICliente } from "../../entities/catalogos/ICliente";
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import { initialMercanciaComplementaria } from '../../redux/reducers/mercanciaDatosComplementariosReducer';
import AutocompleteMercanciaControl from '../controls/AutocompleteMercanciasControl';
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';
import { IParametro } from "../../redux/types/parametroActionTypes";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import {
    esCartaPorteDetalleActivo,
    esPaisEuRecoleccionGuia,
    validarComplementariosGuia
} from './guiaMercanciaComplementariosHelpers';
import { setGuiaMercanciasComplementarias } from "../../redux/actions/guiaActions";

interface OwnProps {
    value: MercanciaDatosComplementarios[];
    siguienteTab: (mercancias: MercanciaDatosComplementarios[]) => void;
    clasificacionOrigenId?: number;
    clasificacionDestinoId?: number;
}

interface StateProps {
    cliente: ICliente;
    parametros: IParametro[];
    guiaOrigen: IRecoleccion;
    guiaDestino: IRecoleccion;
}

interface DispatchProps {
    setGuiaMercanciasComplementarias: typeof setGuiaMercanciasComplementarias;
}

type Props = OwnProps & StateProps & DispatchProps;

const MercanciaDatosComplementariosListaGuia = ({
    value,
    siguienteTab,
    clasificacionOrigenId,
    clasificacionDestinoId,
    cliente,
    parametros,
    guiaOrigen,
    guiaDestino,
    setGuiaMercanciasComplementarias
}: Props) => {
    const [mercanciasDatosComplementarios, setMercancias] = useState<MercanciaDatosComplementarios[]>(value ?? []);

    useEffect(() => {
        setMercancias(value ?? []);
    }, [value]);

    useEffect(() => {
        setGuiaMercanciasComplementarias(mercanciasDatosComplementarios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mercanciasDatosComplementarios]);

    const addMercancia = () => {
        const nuevaMercancia = new MercanciaDatosComplementarios(initialMercanciaComplementaria);
        nuevaMercancia.id = mercanciasDatosComplementarios.length === 0 ? 1
            : Math.max(...mercanciasDatosComplementarios.map(m => m.id)) + 1;
        setMercancias([...mercanciasDatosComplementarios, nuevaMercancia]);
    };

    const deleteMercancia = (id: number) => {
        setMercancias(mercanciasDatosComplementarios.filter(m => m.id !== id));
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: MercanciaDatosComplementarios) => {
        const name = event.target.name || "";
        const fieldValue = event.target.value;
        mercancia.esFormaValida = true;

        const copiaMercancia = new MercanciaDatosComplementarios(mercancia);
        copiaMercancia.LimpiarCampos(name);

        if (!fieldValue || fieldValue === "") {
            copiaMercancia[name] = "";
        } else {
            copiaMercancia[name] = fieldValue;
        }

        setMercancias(mercanciasDatosComplementarios.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleSiguienteTab = () => {
        const cartaPorteDetalleActivo = esCartaPorteDetalleActivo(cliente);
        const origenEu = esPaisEuRecoleccionGuia(guiaOrigen);
        const destinoEu = esPaisEuRecoleccionGuia(guiaDestino);
        const resultado = validarComplementariosGuia(
            mercanciasDatosComplementarios,
            cliente,
            parametros,
            cartaPorteDetalleActivo,
            origenEu,
            destinoEu,
            clasificacionOrigenId,
            clasificacionDestinoId
        );

        if (!resultado.ok) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(resultado.messageId ?? 101),
                type: 'warning',
            });
            return;
        }

        siguienteTab(mercanciasDatosComplementarios);
    };

    const handleClave = (optionSelected, row, campo: string) => {
        const copiaMercancia = new MercanciaDatosComplementarios(row);

        if (optionSelected === null) {
            if (campo === 'claveUnidadId') {
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(121),
                    type: 'warning',
                });
            } else if (campo === 'claveProductoId') {
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(120),
                    type: 'warning',
                });
            } else if (campo === 'claveFraccionArancelariaId') {
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(125),
                    type: 'warning',
                });
            }

            copiaMercancia[campo] = '';
            if (campo === 'claveUnidadId') copiaMercancia.claveUnidad = null;
            if (campo === 'claveProductoId') copiaMercancia.claveProducto = null;
            if (campo === 'claveFraccionArancelariaId') copiaMercancia.claveFraccionArancelaria = null;
        } else if (optionSelected.clave) {
            copiaMercancia[campo] = optionSelected.clave;
            if (campo === 'claveUnidadId') copiaMercancia.claveUnidad = optionSelected;
            if (campo === 'claveProductoId') copiaMercancia.claveProducto = optionSelected;
            if (campo === 'claveFraccionArancelariaId') copiaMercancia.claveFraccionArancelaria = optionSelected;

            if (campo === 'claveProductoId' && optionSelected.materialPeligroso === "1") {
                const message = traducirMessage(136).replace('#####', `${optionSelected.clave}`);
                swal.fire({
                    titleText: traducirMessage(11),
                    text: message,
                    type: 'warning',
                });
            }
        }

        setMercancias(mercanciasDatosComplementarios.map(m => m.id !== row.id ? m : copiaMercancia));
    };

    return (
        <ValidatorForm onSubmit={handleSiguienteTab}>
            <TableContainer component={Paper} style={{ marginTop: "10px" }}>
                <Table className="table-xs" size="small" aria-label="guia-datos-complementarios">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ width: "5%" }}>
                                {traducirLabel(29)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "20%" }}>
                                {traducirLabel(37)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "20%" }}>
                                {traducirLabel(36)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "15%" }}>
                                {traducirLabel(81)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "15%" }}>
                                {traducirLabel(144)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "5%" }}>
                                {traducirLabel(313)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "8%" }}>
                                {traducirLabel(231)}
                            </TableCell>
                            <TableCell style={{ padding: 0, width: "4%" }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mercanciasDatosComplementarios.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>
                                    <TextValidator
                                        value={row.cantidad || ""}
                                        name="cantidad"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 2, maxLength: 8 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl
                                        name="claveUnidadId"
                                        source={"solicitud-servicio/get-catalogo-clave-unidad/" + cliente.id.toString()}
                                        label={traducirLabel(37)}
                                        required={true}
                                        onChange={(e, value) => handleClave(value, row, 'claveUnidadId')}
                                        value={row.claveUnidad || ""}
                                    />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl
                                        name="claveProductoId"
                                        source={"solicitud-servicio/get-catalogo-clave-producto/" + cliente.id.toString()}
                                        label={traducirLabel(36)}
                                        required={true}
                                        onChange={(e, value) => handleClave(value, row, 'claveProductoId')}
                                        value={row.claveProducto || ""}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.descripcionMercancia || ""}
                                        name="descripcionMercancia"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl
                                        name="claveFraccionArancelariaId"
                                        source={"solicitud-servicio/get-catalogo-fraccion-arancelaria/" + cliente.id.toString()}
                                        label={traducirLabel(144)}
                                        onChange={(e, value) => handleClave(value, row, 'claveFraccionArancelariaId')}
                                        required={false}
                                        value={row.claveFraccionArancelaria}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.uuidComprobante}
                                        name="uuidComprobante"
                                        onChange={(e) => handleChange(e, row)}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.peso || ""}
                                        name="peso"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell style={{ padding: "0 5px 0 0" }}>
                                    {mercanciasDatosComplementarios.length > 0 &&
                                        <DeleteIcon
                                            color="error"
                                            style={{ fontSize: "1rem" }}
                                            className="pointer"
                                            onClick={() => deleteMercancia(row.id)}
                                        />
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={2} className="text-right">
                <Button color="primary" size="small" startIcon={<AddCircleIcon />} onClick={addMercancia}>
                    {traducirLabel(8)}
                </Button>
            </Box>

            {cliente.habilitarDatosCompCartaPorteDetalle &&
                <SubmitButton label={traducirButton(15)} />
            }
            {!cliente.habilitarDatosCompCartaPorteDetalle &&
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button onClick={handleSiguienteTab} variant="contained" color="primary">
                        {traducirButton(15)}
                    </Button>
                </Box>
            }
        </ValidatorForm>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    parametros: state.parametros,
    guiaOrigen: state.guiaOrigen,
    guiaDestino: state.guiaDestino
});

const mapDispatchToProps = {
    setGuiaMercanciasComplementarias
};

export default connect(mapStateToProps, mapDispatchToProps)(MercanciaDatosComplementariosListaGuia);
